const loadScript = () => {
    if (document.getElementById("AwsWAFScript")) return;

    const AwsWafScript = document.createElement("script");
    AwsWafScript.id = "AwsWAFScript";
    AwsWafScript.async = false;
    AwsWafScript.src = process.env.JSAPI_URL || "";
    document.head.appendChild(AwsWafScript);
};

export { loadScript };
